@if (condition) {
  <div class="transport-option-condition-editor" [formGroup]="detailsFormGroup">
    <div class="row">
      <mat-form-field class="flex-grow" appearance="fill">
        <mat-label>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-option-condition-editor.transportoption"></sc-dictionary-label>
        </mat-label>
        <mat-select formControlName="transportOptionExternalKey" name="transportOptionExternalKey">
          <mat-option [value]="-1">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-option-condition-editor.transportoption.none"></sc-dictionary-label>
          </mat-option>
          @for (to of transportOptions; track to) {
            <mat-option [value]="to.externalKey">
              <sc-dictionary-label [dictionaryKey]="to.nameDictionaryKey"></sc-dictionary-label>
            </mat-option>
            @for (child of to.transportOptions; track child) {
              <mat-option [value]="child.externalKey">
                &nbsp;&nbsp;
                <sc-dictionary-label [dictionaryKey]="child.nameDictionaryKey"></sc-dictionary-label>
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
